<template>
  <Input
    :value="props.modelValue"
    :placeholder="placeholder"
    class="w-full"
    @input="handleDebouncedInput"
  />
</template>

<script setup lang="ts">
import { Input } from '@/components/ui/input'
import { useDebounceFn } from '@vueuse/core'

const props = defineProps<{
  modelValue: string
  placeholder?: string
}>()

const emit = defineEmits(['update:modelValue'])

const handleDebouncedInput = useDebounceFn((event: Event) => {
  emit('update:modelValue', (event.target as HTMLInputElement).value)
}, 300)
</script>
